module.exports = __webpack_public_path__ + "img/arrow-going-up-alt.cbf4c89f.svg";